module.exports = __webpack_public_path__ + "img/1cube to 1bakkie.e661f69e.svg";